<template>
  <div class="read-only subscriptions-read-only">
    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Name
      </label>
      <div>
        {{ subscription.name }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Account
      </label>
      <div>
        {{ subscription.account.name }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Package
      </label>

      <entitlements
        v-if="subscription.roles"
        :permissions="subscription.roles.permissions"
        class="mt-3 read-only-packages"
      />
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Start Date
      </label>
      <div>
        {{ subscription.starts_at }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        End Date
      </label>
      <div>
        {{ subscription.ends_at || '---' }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Complimentary Research
      </label>
      <div>
        {{ subscription.is_complimentary ? 'On' : 'Off' }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Auto Renew
      </label>
      <div>
        {{ subscription.is_auto_renew ? 'On' : 'Off' }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Access for All Account Users
      </label>
      <div>
        {{ subscription.is_all_users ? 'On' : 'Off' }}
      </div>
    </div>

    <div class="d-flex flex-column read-only__item">
      <label class="text-black">
        Trial Subscription
      </label>
      <div>
        {{ subscription.is_trial ? 'On' : 'Off' }}
      </div>
    </div>
  </div>
</template>

<script>
import Entitlements from '@/components/Entitlements'

export default {
  components: {
    Entitlements,
  },

  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.read-only-packages {
  width: 70%;

  @media(max-width: 992px) {
    width: 100%;
  }
}
</style>
